import React from 'react'
import { Grid } from '@mui/material'
import { Route, Redirect, Switch } from 'react-router-dom'

import SignInForm from '../auth/SignInForm'
import RecoverPasswordForm from '../auth/RecoverPasswordForm'

export default function ExternApp() {
    return (
        <Grid
            id="extern-app"
            container
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '100vh' }}
        >
            <Switch>
                <Route
                    path="/recover-password"
                    component={RecoverPasswordForm}
                />
                <Route path="/" component={SignInForm} />
                <Redirect from="/*" to="/" />
            </Switch>
        </Grid>
    )
}
